import { Component, OnInit, input, signal } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';
import { ConnectionService } from '@services/connection-service';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { ProcessingBannerComponent } from '@shared/home-banners/processing-banner/processing-banner.component';

@Component({
  selector: 'report-getting-ready',
  imports: [
    ProcessingBannerComponent
  ],
  templateUrl: './report-getting-ready.html',
  styles: '',
  standalone: true
})
export class ReportGettingReadyComponent implements OnInit {
  // Signal so the async doctor fetch propagates through OnPush ancestors
  // (e.g. FollowUpQuestionsWidgetComponent). A plain object mutation here
  // never gets read by the template under an OnPush parent — the widget
  // doesn't tick, so the inner template stays at the empty initial values.
  readonly doctor = signal<{ firstName: string; image: string }>({ firstName: '', image: '' });
  // Optional pass-through to ProcessingBanner.margin. When unset, the banner
  // keeps its default tw-mx-4 horizontal margin.
  readonly margin = input<string | undefined>(undefined);

  user: Table.User;

  constructor(
    private readonly eventLogger: EventLoggerService,
    private readonly conn: ConnectionService,
    private readonly userAllocatedDoctorService: UserAllocatedDoctorService,
  ) {}

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    void this.getDoctorData();
  }

  async getDoctorData(): Promise<void> {
    const doctor = this.user?.get('allocatedDoctor');
    if (!doctor) return;
    const allocatedDoctor = await this.userAllocatedDoctorService.getAllocatedDoctor();
    if (!allocatedDoctor) return;
    const doctorName = allocatedDoctor.DoctorDisplayName || allocatedDoctor.username;
    this.doctor.set({
      firstName: doctorName.split(' ').slice(0, 2).join(' ') || '',
      image: allocatedDoctor.DoctorImageThumbnail || '',
    });
  }

  handleClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'level-two-report-in-process-banner' }));
  }
}
